import React from 'react';
import styled from '@emotion/styled';

import AddPlanner from "./Planner/AddPlanner";

const Container = styled.div`
  color: ${props => props.theme.colors.dark};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  margin: ${props => props.theme.size.medium} auto;
  padding-left: ${props => props.theme.size.medium};
  max-width: 1000px;

  ${props => props.theme.breakpoint.tablet} {
    flex-direction: row;
  }
`

const PlannerContainer = styled.div`
  margin: 100px 0;
`

const Animation = styled.img`
  align-self: center;
  padding: 15px;
  width: 65%;

  ${props => props.theme.breakpoint.tablet} {
    width: 40%;
  }
`

const List = styled.div`
  padding: ${props => props.theme.size.medium};
  width: 100%;

  ${props => props.theme.breakpoint.tablet} {
    width: 60%;
  }
`

const ListHeading = styled.h3`
  color: ${props => props.theme.colors.dark};
  padding: ${props => props.theme.size.xlarge} 0 ${props => props.theme.size.xsmall};
`

const PlannerHeading = styled.h3`
  color: ${props => props.theme.colors.dark};
  padding-bottom: ${props => props.theme.size.large};
  text-align: center;
`

class LandingPage extends React.Component {
  render() {
    return (
      <div>
        <Container>
          <Animation src="media/lapduck-animation.gif" />
          <List>
            <div>
              <ListHeading>1. Master your art</ListHeading>
              <p>
                You have an upcoming exam or just want to keep track of your progress?
                Your Learning Activity Planner helps you master it.
              </p>
            </div>
            <div>
              <ListHeading>2. Learn efficiently</ListHeading>
              <p>
                Don't waste time revising something you have already mastered.
                Instead, revise what you are least comfortable in. Log and rate each session. Keep track of your progress over time. Learn efficiently
              </p>
            </div>
            <div>
              <ListHeading>3. Time to study</ListHeading>
              <p>
                Check your LAP and find what topic you are least comfortable in. Time to study!
              </p>
            </div>
          </List>
        </Container>
        <PlannerContainer>
          <PlannerHeading>Add your first planner</PlannerHeading>
          <AddPlanner addPlanner={this.props.addPlanner} intro={false} align={"center"} />
        </PlannerContainer>
      </div>
    );
  }
}

export default LandingPage;
